import React, {Fragment} from "react";
import classes from "classnames";
import {Button} from "react-bootstrap";
import * as PropTypes from "prop-types";

import icn_remove from '../../../../assets/svg/actions/icn-remove.svg'
import Icon from "../../Icon";

import '../../../../assets/sass/components/general/participants/participant.scss';

class Participant extends React.Component {

    state = {
        active: false
    }

    componentWillReceiveProps(nextProps, nextContext) {
        var {active} = this.state;
        var {data} = this.props;

        // this if we change selected state from outside
        if(data.selected != active) {
            this.setState({active: data.selected});
        }
    }

    memberClick = (event, key, active) => {
        var { toggleSelected } = this.props;
        this.setState({
            active: !active
        })
        if(toggleSelected)
            toggleSelected(key, !active)
    }

    onFixedIconClick = (event, key) => {
        if(this.props.onFixedIconClick)
            this.props.onFixedIconClick(event, key);
    }

    deleteMember = (event, key) => {
        var { deleteItem } = this.props;

        if(deleteItem)
            deleteItem(key)
    }

    toggleIcon = () => {
        var { active } = this.state;
        var { hasToggleIcon, activeIcon, inactiveIcon } = this.props;

        return hasToggleIcon ? (
            <div className="toggle">
                <Button variant="link">
                    {
                        active ? (
                            activeIcon ? <Icon svg={activeIcon}/> : null
                        ) : (
                            inactiveIcon ? <Icon className="primary" svg={inactiveIcon}/> : null
                        )
                    }
                </Button>
            </div>
        ) : null
    }

    fixedIcon = (key) => {
        var { active } = this.state;
        var { fixedIcon } = this.props;

        return fixedIcon ? (
            <Button variant="link" onClick={(event) => { this.onFixedIconClick(event, key) }}>
                <Icon svg={fixedIcon}/>
            </Button>
        ) : null
    }

    closeIcon = () => {
        var { hasClose, data } = this.props;

        return hasClose ? (
            <span className="close-icon" onClick={(e) => this.deleteMember(e, data.key)}>
                <Icon svg={icn_remove}/>
            </span>
        ) : null;
    }

    render() {

        var { active } = this.state;
        var { hasToggleIcon, data } = this.props;

        return (
            <div key={data.key} className={classes("participant member-item", hasToggleIcon ? 'member-item-hand' : null, hasToggleIcon && active ? "active" : null)} onClick={(e) => this.memberClick(e, data.key, active)}>
                <div className="d-flex">
                    <img src={data.avatar} alt={data.name}/>
                    <div className="member-item-info d-flex flex-column">
                        <h3>{data.name}</h3>
                        <span>{data.info}</span>
                    </div>
                </div>
                {this.toggleIcon()}
                {this.fixedIcon(data.key)}
                {this.closeIcon()}
            </div>
        );
    }

    static propTypes = {
        // object array to fill data.
        data: PropTypes.object.isRequired,
        // is has icon
        hasToggleIcon: PropTypes.bool,
        // active icon.
        activeIcon: PropTypes.string,
        // inactive icon.
        inactiveIcon: PropTypes.string,
        // fixed Icon.
        fixedIcon: PropTypes.any,
        // fixed Icon event.
        onFixedIconClick: PropTypes.func
    };

    static defaultProps = {
        hasToggleIcon: true,
    };
}

export default Participant;


